import { z } from 'zod';

export const cleanCep = (input: string): string => input.replace(/\D/g, '');

export const isValidCep = (input: string): boolean => /^\d{8}$/.test(cleanCep(input));

export const formatCep = (input: string): string => {
  const digits = cleanCep(input).slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
};

export const cepSchema = z
  .string()
  .transform(cleanCep)
  .refine(isValidCep, { message: 'CEP inválido.' });

export interface StreetAddress {
  street: string;
  number: string;
  complement?: string | null;
  neighborhood?: string | null;
  cep?: string | null;
}

/**
 * Endereço numa linha, no jeito brasileiro: `Rua Exemplo, 123, Sala 2 -
 * Centro, CEP 87047-030`. Cidade e UF ficam em colunas próprias do lote.
 */
export const formatStreetAddress = (address: StreetAddress): string => {
  const parts = [`${address.street.trim()}, ${address.number.trim()}`];
  const complement = address.complement?.trim();
  if (complement) parts[0] += `, ${complement}`;
  const neighborhood = address.neighborhood?.trim();
  if (neighborhood) parts.push(neighborhood);
  const line = parts.join(' - ');
  const cep = address.cep ? cleanCep(address.cep) : '';
  return isValidCep(cep) ? `${line}, CEP ${formatCep(cep)}` : line;
};
